export function isPhoneNumberEmail(email: string): boolean {
    /*
     * Regex matches against a string that:
     *    - optionally starts with a "+" symbol
     *    - followed by 6-15 digits
     *    - followed by an "@" symbol
     */
    return /^\+?\d{6,15}@.*$/.test(email);
}
